const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class PushCartCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.setupCarousel()
      }, 500),
    )
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isSm) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.1,
          spacing: 14,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('push-cart-carousel')) {
  customElements.define('push-cart-carousel', PushCartCarousel)
}
